import { useState } from "react";
import { Button } from "@mui/material";
import GenerateBillOfSaleModal from "../GenerateBillOfSaleModal/GenerateBillOfSaleModal";

const GenerateBillOfSaleButton = () => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        sx={{
          ml: 2,
        }}
      >
        Generate Bill of Sale
      </Button>
      <GenerateBillOfSaleModal open={openModal} onClose={handleClose} />
    </>
  );
};

export default GenerateBillOfSaleButton;
